import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export enum DialogBoxButton  {
  OK = 1,
  YesNo = 2,
  CustomButtons = 3
}


export interface CustomDialogBoxButton {
  name: string;
  actionCode: string;
  colorType: string;
}


export interface DialogBoxData {
  message: string;
  button: DialogBoxButton;
  customButtons: CustomDialogBoxButton[];
  data: any;
}


@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})

export class DialogBoxComponent {

  param: DialogBoxData;
  DialogBoxButtonType = DialogBoxButton;

  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogBoxData) {
    this.param = {...data}; // create a copy
  }

  doAction() {
    this.dialogRef.close({event: 'Ok', data: this.param.data});
  }

  doCustomAction(actionCode) {
    this.dialogRef.close({event: actionCode, data: this.param.data});
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
